import { render, staticRenderFns } from "./AddFirmUser.vue?vue&type=template&id=88b06584&scoped=true&"
import script from "./AddFirmUser.vue?vue&type=script&lang=js&"
export * from "./AddFirmUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b06584",
  null
  
)

export default component.exports